import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Infrastructure from "./sections/Infrastructure";
import GrantAdministration from "./sections/GrantAdministration";
import Planning from "./sections/Planning";
import Stakeholder from "./sections/Stakeholder";
import Procurement from "./sections/Procurement";
import Reporting from "./sections/Reporting";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Infrastructure />
      <GrantAdministration />
      <Planning />
      <Stakeholder />
      <Procurement />
      <Reporting />
      <Footer />
    </div>;
}